<!-- 智能仓储 -->
<template>
  <div class="keep">
    <!-- 背景图 -->
    <TopImg :title="topImg.title" :content="topImg.content" :image="topImg.bgImg" :bl="topImg.bl"></TopImg>
    <!-- 方案简介 -->
    <Introduction :title="propsCon.title" :content="propsCon.content" :image="propsCon.img"></Introduction>
    <!-- 产品功能 -->
    <div class="gn">
      <h3 class="h3">产品功能</h3>
      <div class="gnCon width">
        <div class="gnItem" v-for="(item,i) in listData" :key="i">
          <p>{{item.title}}</p>
        </div>
      </div>
    </div>
    <!-- 系统架构 -->
    <TitleImg :title="titleImg.title" :image="titleImg.img" :wwidth="titleImg.wwidth"></TitleImg>
    <!-- 方案优选 -->
    <div class="gatherPlay">
      <h3 class="h3">方案优势</h3>
      <ListItem :modelList="modelList" class="listModel"></ListItem>
    </div>
    <!-- 提交方案咨询 -->
    <div class="subPlay">
      <el-button type="primary" icon="el-icon-s-order">提交方案咨询</el-button>
    </div>
    <!-- 底部 -->
    <div class="el-footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import TopImg from '../components/TopImg'
import Introduction from '../components/Introduction'
import TitleImg from '../components/TitleImg'
import ListItem from '../components/ListItem'
import Footer from '../components/Footer.vue'
export default {
  name: '',
  components: { TopImg, Introduction, TitleImg, ListItem, Footer },
  props: {},
  data() {
    return {
      topImg: {
        title: '智能仓储',
        bgImg: require('../assets/images/u2006.jpg'),
        content:
          '帮助客户改进仓储、配送、运输，优化物流作业，实现仓储移动供应链管理。提高仓储配送效率准备率，实现精确的仓储作业事务跟踪记录，做到可追溯，可统计。',
        bl: true,
      },
      propsCon: {
        title: '方案简介',
        content: [
          '企业上云是指企业通过网络,智能仓储解决方案主要是通过入库业务、出库业务、仓库调拨、库存调拨和虚仓管理等功能，综合批次管理、物料对应、库存盘点、质检管理、即时库存管理等功能综合运用的管理系统，有效控制并跟踪仓库业务的物流和成本管理全过程，实现完善的企业仓储信息管理。运用AGV配送管理，实现厂内物料和产品智能化运输，节省人力和搬运成本；利用条形码技术，对仓储各环节实施全过程控制管理，并可对货物进行货位、批次、保质期、配送等实现条形码标签序列号管理，对整个物流环节的规范化作业 , 客制作多种 统计报表 .凭借丰富的条码技术及多年实施条码系统的经验，解决库房信息陈旧滞后的弊病，帮助企业合理有效地利用仓库空间，以快速、准确、低成本的方式为客户提供最好的服务。+数”战略的设备在线监测应用解决方案。设备在线监测和数据采集应用提供设备的状态监测、关键参数监测、能效管理、异常报警等服务。帮助管理人员全面、准确评估重要设备工作情况，协助技术人员评估关键设备的实时性能，为维护人员为设备维修保养提供数据支持。可有效降低设备运行能耗，提高设备运维效率，有效减少企业设备非计划停机，减少因为停机带来的产能损失，提高设备寿命，实现生产设备全生命周期健康管理，为企业带来显著的经济效益。 以及跨国家、跨地域、跨行业、跨企业的全球信息互联互通能力，是整个工业互联网网络实现互联互通的关键基础设施。主要由三要素组成：一是标识，这就相当于机器、物品的“身份证”；二是标识服务，即利用标识，对机器和物品进行唯一性的定位和信息查询，是实现全球供应链系统和企业生产系统的精准对接、产品的全生命周期管理和智能化服务的前提和基础；三是标识管理，即通过国家工业互联网标识解析体系，实现标识的申请、注册、分配、备案，为机器、物品分配唯一的编码。',
        ],
        img: require('../assets/images/u2014.png'),
      },
      listData: [
        {
          title:
            '基础信息管理：物料、托盘信息、库区、PDA管理、分拣口管理、仓库参数配置。',
        },
        {
          title:
            '出库管理：出库单据管理、订单发货、先入品出库、空笼出库、其他出库、库内移库。',
        },
        {
          title:
            '入库管理：组盘信息查询、入库类型维护、入库信息查询、入库单据管理、手动建立组盘信息、入库收货。',
        },
        {
          title: '入库策略管理：均匀分布、ABC原则、分区存放。',
        },
        {
          title: '盘点管理：盘点出库、盘点确认、盘点差异调整。',
        },
        {
          title:
            '信息报表与查询：库存信息、发货信息、作业任务信息、设备状态、库位状态、出入库历史、轮胎全生命周期、异常信息查询。',
        },
        {
          title: '设备状态监控：监控堆垛机状态、输送线体状态、RGV状态。',
        },
        {
          title:
            '任务指令拆解、排队、调度：出入库任务拆解（堆垛机任务、AGV输送线任务），发货任务排序调度。',
        },
        {
          title:
            '设备指令下发：与设备端进行数据交换，将所需下达的任务，组织任务命令下发给执行层。',
        },
      ],
      titleImg: {
        title: '系统架构',
        img: require('../assets/images/u2039.png'),
      },
      modelList: [
        {
          title: '经济效益',
          content: [
            '无纸化的操作，减少纸张的开销；',
            '提高仓储作业、发货配送等各操作环节的工作效率',
            '增加库存的准确率，提高货物周转率；',
            '大大节约了人工成本，为企业节省资源；',
            '有效的库存空间利用，降低营运成本；',
          ],
          img: require('../assets/images/u1877.png'),
        },
        {
          title: '管理效益',
          content: [
            '条码识别的正确性高，减少人为的错误；',
            '优化仓库入库、出库、转储及盘点作业流程；',
            '各种当前和历史事务的数据为仓库的所有活动、资源和库存水平提供即时的正确信息；',
            '数据交换接口的连通，增强企业现有应用系统的管理。',
          ],
          img: require('../assets/images/u1881.png'),
        },
        {
          title: '追溯效益',
          content: [
            '为仓库作业全过程提供自动化和全面纪录的途径；',
            '通过条码智能手持终端随时追踪托板及板上货物的当前状态信息和具体流向；',
            '有效的库存管理和控制，减少额外的采购，同时保证库存量满足客户订货或生产计划的需要。',
          ],
          img: require('../assets/images/u1885.png'),
        },
        {
          title: '扩展效益',
          content: ['通过接口集成实现系统间的信息共享。', '节省信息化成本。'],
          img: require('../assets/images/u1889.png'),
        },
      ],
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
}
</script>

<style lang="less" scoped>
.gn {
  background: url('../assets/images/u1795.png') no-repeat;
  background-size: cover;
  padding-top: 20px;
  margin-bottom: 10px;
  padding-bottom: 20px;
  .h3 {
    width: 140px;
    height: 25px;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    color: #fff;
    text-align: center;
    padding-bottom: 10px;
    border-bottom: 2px solid #0078d7;
    margin: 0 auto 20px auto;
  }
  .gnCon {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    .gnItem {
      flex: 1 1 25%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 30px;
      height: 170px;
      padding: 0 20px;
      background-color: rgba(242, 242, 242, 1);
    }
  }
}
.gatherPlay {
  background: url('../assets/images/u1872.png') no-repeat;
  background-size: cover;
  padding-top: 20px;
  margin-bottom: 10px;
  padding-bottom: 20px;
  .h3 {
    width: 140px;
    height: 25px;
    font-weight: 700;
    font-style: normal;
    font-size: 20px;
    color: #fff;
    text-align: center;
    padding-bottom: 10px;
    border-bottom: 2px solid #0078d7;
    margin: 0 auto 20px auto;
  }
}
.subPlay {
  text-align: center;
  padding: 60px 0;
  background-color: #fff;
}
</style>
